<template>
  <div class="page-content list-page">
    <div class="page-content-white">
      <q-table
          :dense="$q.screen.lt.md"
          :data="items"
          :columns="columns"
          :filter="filters.search"
          row-key="id"
          :visible-columns="visibleColumns"
          :pagination.sync="pagination"
      >

        <template v-slot:top-right>
          <div class="q-mx-md">
            <user-select :item="filters" label="Select user" prop="user_id"></user-select>
          </div>

          <date-picker value-type="format"
                       format="DD/MM/YYYY"
                       id="date_from"
                       label="Date From"
                       ref="date_from"
                       style="max-width: 100px; margin: 0 10px"
                       v-model="filters.date_from"
          ></date-picker>

          <date-picker value-type="format"
                       format="DD/MM/YYYY"
                       id="date_to"
                       style="max-width: 100px"
                       label="Date To"
                       ref="date_to"
                       v-model="filters.date_to"
          ></date-picker>

          <q-input dense
                   debounce="300"
                   v-model="filters.search"
                   class="q-mx-md"
                   label="Search">
            <template v-slot:append>
              <q-icon name="ion-ios-search"/>
            </template>
          </q-input>

          <q-select
              v-model="visibleColumns"
              multiple
              outlined
              dense
              options-dense
              :display-value="$q.lang.table.columns"
              emit-value
              map-options
              :options="columns"
              option-value="name"
              options-cover
              style="min-width: 150px"
          />
        </template>

        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="id"
                  :props="props">
              {{props.row.id}}
            </q-td>
            <q-td key="created_at_formatted"
                  :props="props"
                  class="text-capitalize">
              {{props.row.created_at_formatted}}
            </q-td>
            <q-td key="user_id"
                  :props="props">
              {{props.row.user ? props.row.user.full_name : ''}}
            </q-td>
            <q-td key="status"
                  :props="props">
              {{props.row.status}}
            </q-td>
            <q-td key="price"
                  :props="props">
              ${{props.row.price}}
            </q-td>
            <q-td key="comment">
              {{props.row.comment}}
            </q-td>
            <q-td key="admin_comment">
              {{props.row.admin_comment}}
            </q-td>
            <q-td key="edit"
                  :props="props">
              <q-btn flat
                     @click="openEditQuote(props.row)"
                     icon="far fa-file-alt"/>

            </q-td>
            <q-td key="clone"
                  :props="props">
              <q-btn flat
                     @click="openEditQuote(props.row, true)"
                     icon="far fa-copy"/>

            </q-td>
            <q-td key="remove"
                  :props="props">
              <q-btn flat
                     color="negative"
                     icon="fas fa-trash-alt"
                     @click="deleteItem(props.row)"/>

            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
  import EditQuote from "./EditQuote.vue";
  import UserSelect from "./UserSelect.vue";
  import 'vue2-datepicker/index.css';
  import DatePicker from "vue2-datepicker";

  export default {
    name: 'CategoriesPage',
    components: {UserSelect, DatePicker},
    data() {
      return {
        pagination: {
          sortBy: 'desc',
          descending: false,
          page: 1,
          rowsPerPage: 20
          // rowsNumber: xx if getting data from a server
        },
        columns: [],
        users: [],
        visibleColumns: [],
        items: [],
        filters: {
          status: '',
          user_id: '',
          search: '',
          date_from: '',
          date_to: '',
        }
      };
    },
    watch: {
      filters: {
        deep: true,
        handler(){
          this.getList()
        }
      }
    },
    mounted() {
      let cols = {
        id: 'ID #',
        created_at_formatted: 'Created',
        user_id: 'User',
        status: 'status',
        price: 'Price',
        comment: 'User Comment',
        admin_comment: 'Admin Comment',
        edit: 'Edit',
        clone: 'Clone',
        remove: 'Delete',
      };

      for (let col in cols) {
        let align = ['is_active', 'edit', 'remove',].indexOf(col) > -1 ? 'center' : 'left';
        let sortable = ['edit', 'remove',].indexOf(col) <= -1;

        this.columns.push({
          name: col,
          label: cols[col],
          field: col,
          align: align,
          sortable: sortable,
        });
      }

      this.visibleColumns = Object.keys(cols)

      this.getList();
    },
    methods: {
      openEditQuote(quote, clone = false){

        let v = JSON.parse(JSON.stringify(quote || {}))

        if(clone){
          delete v.id
        }

        this.$q.dialog({
          component: EditQuote,

          // optional if you want to have access to
          // Router, Vuex store, and so on, in your
          // custom component:
          parent: this, // becomes child of this Vue node
                        // ("this" points to your Vue component)
                        // (prop was called "root" in < 1.1.0 and
                        // still works, but recommending to switch
                        // to the more appropriate "parent" name)

          // props forwarded to component
          // (everything except "component" and "parent" props above):
          quote: v,
        }).onOk(() => {
          this.getList()
        })
      },
      getList() {
        this.$q.loading.show();

        this.$axios.post(this.$apiUrl + `/${this.routePrefix}/list`, this.filters)
          .then((r) => {
            this.items = r.data;
            this.$forceUpdate()
          })
          .finally(() => {
            this.$q.loading.hide();
          });
      },
      toggleEnabled(item) {
        this.$axios.post(this.$apiUrl + `/${this.routePrefix}/toggle/` + item.id)
          .then((r) => {
            item.is_active = !item.is_active;

            this.$q.notify({
              message: 'Quote ' + (item.is_active ? 'enabled' : 'disabled') + '!',
              type: 'positive',
            });
          });
      },
      deleteItem(item) {
        this.$q.dialog({
            title: 'Confirm',
            message: `Are sure want to delete ${item.name} quote?`,
            cancel: true,
            persistent: true
          })
          .onOk(() => {
            this.$axios.post(this.$apiUrl + `/${this.routePrefix}/delete`, item)
              .then((r) => {
                this.getList();
                this.$q.notify({
                  message: `Quote ${item.name} deleted!`,
                  type: 'positive',
                });
              })
              .finally(() => {
                this.$q.loading.hide();
              });
          });
      },
    },
    computed: {
      routePrefix(){
        return 'admin_quotes'
      }
    }
  }
</script>
